<template>
	<div class="edit-modal">
		<div class="edit-modal-content">
			<form action="" method="POST" @submit.prevent="$emit('save', items)">
				<div class="title">
					<span>
						{{ title }}
					</span>
					<button
						class="btn close-icon"
						type="button"
						@click="$emit('close-modal')"
					>
						<img
							src="/static/img/icon-close.svg"
							alt="cerrar modal"
							height="24px"
							width="24px"
						>
					</button>
				</div>
				<div class="section text-center">
					<template v-for="(item, key, index) in items">
						<div
							:key="index"
							class="section-item"
							v-if="key !== 'images'
								&& key !== 'name'
								&& key !== 'title'
								&& key !== 'id'"
						>
							<label class="section-title">{{ key }}</label>
							<div v-if="items.name === 'history'">
								<upload-image
									v-if="item.images"
									:label-for="`banner-id-${key}`"
									:label-ref="`banner-img-${key}`"
									:url-image="item.images[0]"
									:visible-more="false"
									@send-image="$emit('send-image', $event, key)"
								/>
							</div>
							<div v-else class="wrapper-upload">
								<upload-image
									v-if="item.images"
									:label-for="`banner-id-${key}`"
									:label-ref="`banner-img-${key}`"
									:url-image="newImage"
									:visible-more="false"
									@send-image="sendImage"
									class="upload-image"
								/>
								<button 
									class="btn-more"
									:class="{'disable-class': !newImage.length}"
									@click.prevent="$emit('send-image-push', newImage, key)">
									<img 
										src="/static/img/icon-plus.svg" 
										alt="agregar imagen"
										height="20px"
										width="20px">
								</button>
							</div>
							<div 
								v-if="items.name === 'about'"
								class="wrapper-images-tabs">
								<div 
									:style="`background-image: url(${item})`" 
									v-for="(item, indexImage) in item.images" 
									:key="indexImage"
									class="image">
										<button 
											class="btn-delete"
											@click.prevent="$emit('delete-image', key, index, indexImage)">
											<img 
												src="/static/img/icon-close-dark.svg" 
												alt="eliminar imagen"
												height="16px"
												width="16px">
										</button>
									</div>
							</div>
							<label :for="`${key}-1`" class="caption">
								Título 
							</label>
							<input
								class="form-input"
								:id="`${key}-1`"
								aria-label="Título"
								placeholder="Título"
								type="text"
								v-model="item.title"
							/>
              
							<div v-if="items.subTitle !== 'Certificaciones'">
								<label :for="`${key}-1`" class="caption">
								Link
								</label>
								<input
								class="form-input"
								:id="`${key}-1`"
								aria-label="Título"
								placeholder="Link"
								type="text"
								v-model="item.link"
								/>
							</div>

							<label :for="`${key}-2`" class="caption">
								Descripción
							</label>
							<vue-editor
								:name="`description-${key}`"
								:id="`description-${key}`"
								placeholder="Descripción"
								class="mb-10"
								:editorToolbar="customToolbar"
								v-model="item.description"></vue-editor>
						</div>
					</template>
					<button class="btn btn-save mt-32" type="submit" >Guardar </button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import uploadImage from '@/components/commons/upload-image';

function data() {
	return {
		newImage: '',
		customToolbar: [
			['bold', 'italic', 'underline'],
			[{ list: 'bullet' }],
			['link'],
		],
	};
}

function sendImage(url) {
	this.newImage = url;
}
export default {
	name: 'edit-modal-section',
	data,
	components: {
		VueEditor,
		uploadImage,
	},
	methods: {
		sendImage,
	},
	props: {
		items: {
			default: () => {},
			type: Object,
		},
		title: String,
	},
};
</script>

<style lang="scss" scoped>
	.caption {
		font-size: 10px;
	}

	.close-icon {
		height: 24px;
		margin: 0px;
		padding: 0px;
		width: 24px;
	}

	.edit-modal {
		align-items: center;
		background-color: rgba(0, 0, 0, .8);
		display: flex;
		height: 100vh;
		justify-content: center;
		left: 0px;
		position: fixed;
		top: 0px;
		width: 100vw;
		z-index: 16;

		&-content {
			background-color: map-get($colors, white);
			max-height: calc(100vh - 200px);
			max-width: 537px;
			overflow: auto;
			width: 90%;
			z-index: 16;
		}

		.section {
			padding: 36px 46px 24px;

			&-item {
				padding-bottom: 15px;
				text-align: left;
			}
		}
	}

	.title {
		align-items: center;
		background-color: map-get($colors, black-dark);
		color: map-get($colors, white);
		display: flex;
		flex-wrap: wrap;
		font-family: map-get($fonts, maison-bold);
		font-size: 24px;
		justify-content: space-between;
		height: 59px;
		padding: 0px 37px;
		text-transform: uppercase;
	}

	.btn-save {
		background-color: map-get($colors, black-dark);
		color: map-get($colors, white);
		font-family: map-get($fonts, open-bold);
		font-size: 14px;
		height: 45px;
		width: 132px;

		&.mt-32 {
			margin-top: 32px;
		}
	}

	.section-title {
		color: map-get($colors, black-dark);
		font-family: map-get($fonts, open-semibold);
		font-size: 14px;
		text-transform: uppercase;
	}

	textarea {
		line-height: 1.5 !important;
		min-height: 100px;
		resize: none;
	}

	.btn-more {
		background-color: #001d32;
		border-radius: 4px;
		height: 30px;
		margin-left: 15px;
		padding: 5px 0px;
		vertical-align: sub;
		width: 30px;
	}

	.wrapper-upload {
		@include display-flex();
		align-items: center;
	}

	.upload-image {
		width: 90%;
	}

	.disable-class {
		cursor: not-allowed;
		opacity: 0.25;
	}

	.image {
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 58px;
		margin: 10px;
		width: 92px;
	}

	.wrapper-images-tabs {
		@include display-flex();
		flex-wrap: wrap;
	}

	.btn-delete {
		@include box-shadow(0, 2px, 7px, 0, rgba(144, 144, 144, 0.5));
		@include flex-center();
		@include border-radius(50%);
		background: map-get($colors, white);
		height: 25px;
		width: 25px;
	}
</style>


// WEBPACK FOOTER //
// src/components/commons/edit-modal-section.vue